import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import CaseList from './components/CaseList';
import Footer from './components/Footer';
import BalanceModal from './components/BalanceModal';
import TonModal from './components/TonModal';
import Profile from './components/Profile';
import Rating from './components/Rating';
import LoadingScreen from './components/LoadingScreen';
import ApiService from './services/apiService';

function App() {
  const [balance, setBalance] = useState(0);
  const [tonBalance, setTonBalance] = useState(0);
  const [isBalanceModalOpen, setIsBalanceModalOpen] = useState(false);
  const [isTonModalOpen, setIsTonModalOpen] = useState(false);
  const [user, setUser] = useState({
    name: 'Lyra',
    username: 'undefined_coder',
    avatar: null,
    id: 'default_user'
  });
  const [loading, setLoading] = useState(true);
  const [showLoadingScreen, setShowLoadingScreen] = useState(true);
  const [loadingFinished, setLoadingFinished] = useState(false);

  useEffect(() => {
    const loadUserBalance = async () => {
      try {
        let balance = 0;
        try {
          balance = await ApiService.getUserBalanceSupabase(user.id);
        } catch (e) {
          // Если пользователя нет — создаём
          await ApiService.createUser({ id: user.id, name: user.name, username: user.username, avatar: user.avatar });
          balance = 0;
        }
        setBalance(balance);
      } catch (error) {
        console.error('Failed to load user balance:', error);
      } finally {
        setLoading(false);
      }
    };
    loadUserBalance();
  }, [user.id]);

  useEffect(() => {
    if (!loading && !showLoadingScreen) {
      setLoadingFinished(true);
    }
  }, [loading, showLoadingScreen]);

  const handleLoadingComplete = () => {
    setShowLoadingScreen(false);
  };

  const openBalanceModal = () => setIsBalanceModalOpen(true);
  const closeBalanceModal = () => setIsBalanceModalOpen(false);

  const openTonModal = () => setIsTonModalOpen(true);
  const closeTonModal = () => setIsTonModalOpen(false);

  const handleTopUp = async (amount) => {
    try {
      setBalance(prev => prev + amount);
      
      console.log(`Topped up stars by ${amount}`);
    } catch (error) {
      console.error('Error updating balance:', error);
    }
  };

  const handleTonTopUp = async (amount) => {
    try {
      setTonBalance(prev => prev + amount);
      
      console.log(`Topped up TON by ${amount}`);
    } catch (error) {
      console.error('Error updating TON balance:', error);
    }
  };

  const refreshBalance = async () => {
    try {
      const balance = await ApiService.getUserBalanceSupabase(user.id);
      setBalance(balance);
    } catch (error) {
      console.error('Failed to refresh balance:', error);
    }
  };

  // Функция для начисления звёзд (используется для Free Case)
  const handleAddStars = (amount) => {
    setBalance(prev => prev + amount);
  };

  if (showLoadingScreen || loading) {
    return <LoadingScreen onLoadingComplete={handleLoadingComplete} />;
  }

  return (
    <Router>
      <div className="App">
        <Header 
          balance={balance}
          tonBalance={tonBalance}
          onAddBalanceClick={openBalanceModal}
          onAddTonClick={openTonModal}
        />
        <main className="App-content">
          <Routes>
            <Route path="/" element={
              <CaseList 
                balance={balance}
                onOpenBalanceModal={openBalanceModal}
                onAddStars={handleAddStars}
              />
            } />
            <Route path="/rating" element={<Rating />} />
            <Route path="/profile" element={<Profile user={user} />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        <Footer />
        <BalanceModal 
          isOpen={isBalanceModalOpen}
          onClose={closeBalanceModal}
          onTopUp={handleTopUp}
          userId={user.id}
        />
        <TonModal
          isOpen={isTonModalOpen}
          onClose={closeTonModal}
          onTopUp={handleTonTopUp}
          userId={user.id}
        />
      </div>
    </Router>
  );
}

export default App; 